// Top level libraries and 3rd party dependencies
import React, { Component } from 'react';
import { func, object } from 'prop-types';

// Redux
import { connect } from 'react-redux';

import {
    getConversationDetails,
    savePIN,
    verifyDOB,
} from '../../actions/session/sessionActions';

// Layout
import VerifyPatient from '../Verify/VerifyPatient';


class ForgotContainer extends Component {
    static propTypes = {
        error: object,
        getConversationDetails: func.isRequired,
        loadingState: object,
        location: object,
        history: object,
        match: object,
        conversationDetails: object.isRequired,
        savePIN: func.isRequired,
        session: object,
        verifyDOB: func.isRequired,
    };

    componentDidMount() {
        this.updateConversationDetails();
    }

    updateConversationDetails = () => {
        const { conversationHash } = this.props.match.params;

        if (conversationHash) {
            this.props.getConversationDetails(conversationHash);
        }
    };

    render = () => {
        const { conversationHash } = this.props.match.params;
        const {
            loadingState,
            conversationDetails,
            savePIN,
            session,
            verifyDOB,
        } = this.props;

        return (
            <VerifyPatient
                conversationHash={conversationHash}
                loadingState={loadingState}
                conversationDetails={conversationDetails}
                savePIN={savePIN}
                session={session}
                verifyDOB={verifyDOB}
            />
        );
    }
}

const mapStateToProps = state => ({
    conversationDetails: state.session.conversationDetails,
    loadingState: state.loadingState,
    session: state.session,
});

const mapDispatchToProps = dispatch => ({
    getConversationDetails: conversationId => dispatch(getConversationDetails(conversationId)),
    savePIN: request => dispatch(savePIN(request)),
    verifyDOB: request => dispatch(verifyDOB(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotContainer);
